import { useContext, useEffect, useState } from 'react';
import "./SendCustomSms.css";
import { useTranslation } from 'react-i18next';
import { Col, Container, Form, Row } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { SMSConfirmationModal } from '../../components/Modals/SMSConfirmationModal/SMSConfirmationModal';
import { Loader } from '../../components/Loader/Loader';
import { Back } from '../../components/Back/Back';
import { ArrowIcon } from '../../components/SvgComponents/ArrowIcon/ArrowIcon';
import { EnterPhoneNumberIcon } from '../../components/SvgComponents/EnterPhoneNumberIcon/EnterPhoneNumberIcon';
import { isMobile } from 'react-device-detect';
import { BatchContext } from '../../contexts/BatchContext';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

export const SendCustomSms = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [openModalPhoneNumberConfirmation, setOpenModalPhoneNumberConfirmation] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [loading, setLoading] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorPhoneNumber, setErrorPhoneNumber] = useState(false);
  const documents = location.state.documents;
  const emailId = location.state.emailId;
  const { isBatchMultisignature } = useContext(BatchContext);
  const signerDTO = Array.isArray(documents) ? documents[0]?.SignerDTO : documents?.SignerDTO;
  const formDTO = signerDTO?.Form;
  const selectedMethod = signerDTO.OTPPrimaryChannel?.toLowerCase();
  const [widthIcon, setWidthIcon] = useState(180);
  const [heightIcon, setHeightIcon] = useState(176);
  const [hasUserInteracted, setHasUserInteracted] = useState(false);
  const [hasValidNumber, setHasValidNumber] = useState(false);

  // On Init
  useEffect(() => {
    if (isMobile) {
      setWidthIcon(120);
      setHeightIcon(115);
    }
    if (location.state?.phoneNumber) {
      setPhoneNumber(location.state.phoneNumber);
      setHasUserInteracted(true);
      setHasValidNumber(isValidPhoneNumber(location.state.phoneNumber));
    }
    if (location.state?.errorCustomSms) {
      setErrorPhoneNumber(true);
    }
  }, [location.state]);

  const handlePhoneChange = (value) => {
    setPhoneNumber(value);
    setHasUserInteracted(true);
    setHasValidNumber(isValidPhoneNumber(value || ''));
  };

  const handleShowCustomPhoneNumber = () => {
    setOpenModalPhoneNumberConfirmation(false);
    setLoading(true);
    let link;
    if (selectedMethod === "sms" || selectedMethod === "whatsapp") {
      link = '/sms';
    } else if (selectedMethod === "smswhatsapp") {
      link = '/select-method-otp';
    }
    navigate(link, {
      state: { documents, emailId, phoneNumber, selectedMethod }
    });
  };

  const handleBack = () => {
    let link = '/document';
    if (formDTO && formDTO.FormDisplay?.toLowerCase() === "onpreview") link = "/document-questions";
    if (isBatchMultisignature) link = '/documents';

    navigate(link, {
      state: {
        documents,
        emailId,
      }
    });
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (isValidPhoneNumber(phoneNumber || '')) {
        setOpenModalPhoneNumberConfirmation(true);
        setShowErrorMessage(false);
      } else {
        setShowErrorMessage(true);
      }
    }
  };

  const handleNextClick = () => {
    if (isValidPhoneNumber(phoneNumber || '')) {
      setOpenModalPhoneNumberConfirmation(true);
      setShowErrorMessage(false);
    } else {
      setShowErrorMessage(true);
    }
  };

  return (
    <>
      {loading && <Loader />}
      {!loading &&
        <Container className="document-preview-container">
          <Row>
            <Col md={12} lg={12} className="document-preview-title">
              <Back handleBack={handleBack} />
            </Col>
            <Col md={2} xs={1}></Col>
            <Col md={12} xs={10} lg={12} className="justify-content-center container-sms-box">
              <Row>
                <Col md={4} lg={4}>
                  <EnterPhoneNumberIcon width={widthIcon} height={heightIcon} />
                </Col>
                <Col md={8} lg={5} className="col-align">
                  <h4 className="sms-title">{t('sms.custom_title')}</h4><br />
                  <p className="sms-description">{t('sms.custom_description_customphonenumber')}</p>
                  <Form className="phone-number-form">
                    <Form.Group className="mb-3" controlId="">
                      <PhoneInput
                        value={phoneNumber}
                        onChange={handlePhoneChange}
                        onKeyDown={handleKeyDown}
                        placeholder={t('sms.custom_phone_number')}
                        international
                        className="phone-number-input"
                      />
                    </Form.Group>
                  </Form>
                  {showErrorMessage && (
                    <div className="error-message align-error-message">
                      {t('sms.custom_error_sending_sms')} <br /> {t('sms.custom_phone_number')}
                    </div>
                  )}
                  {errorPhoneNumber && (
                    <div className="error-message align-error-message">
                      {t('sms.custom_error_sending_sms')} <br /> {t('sms.custom_phone_number')}
                    </div>
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col md={4} xs={0}></Col>
            <Col md={4} xs={12} className="button-margin button-only">
              <button
                type="button"
                className="btn btn-primary btn-active phone-number-button"
                disabled={!hasValidNumber}
                onClick={handleNextClick}
              >
                <span className="cancel-text"> {t('general.next')} </span>
                <ArrowIcon disabled={!hasValidNumber} />
              </button>
            </Col>
          </Row>
          <SMSConfirmationModal
            openModalPhoneNumberConfirmation={openModalPhoneNumberConfirmation}
            setOpenModalPhoneNumberConfirmation={setOpenModalPhoneNumberConfirmation}
            handleShowCustomPhoneNumber={handleShowCustomPhoneNumber}
            phoneNumber={phoneNumber}
          />
        </Container>
      }
    </>
  );
};
